/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck

import React from 'react';
import { Accordion, Spinner } from 'react-bootstrap';
import { ListItemsComp } from '../ListItems';
import { ITimelineProps, TimelineComp } from '../TimelineComp';
import { CheckedItems } from '../CheckedItems';

export interface ITimelineProps {
  items?: any[];
}
// import { TableComp } from "../TableComp";
// import { HeroSection, IHeroSectionProps } from "../HeroSection";
// import { CarouselSection, ICarouselSectionProps } from "../CarouselSection";

import * as S from './styles';

interface ICredentialItem {
  label: string;
  value: string;
}

interface IListTableItemProps {
  label: string;
  value: string;
  icon?: string;
}

export interface IAccordionProps {
  policyDetails?: any;
  beneficiaryDetails?: any;
  policyEvents?: any;
  beneficiaryEvents?: any;
  timelineDetails?: any;
  useOfProceedDetails?: any;
  // credentialItem?:ICredentialItem;
}

export const AccordionComp = (props: IAccordionProps) => {
  const {
    policyDetails,
    policyEvents,
    timelineDetails,
    beneficiaryDetails,
    useOfProceedDetails,
  } = props;

  // const { items } = props;

  const _getTimeline = () => {
    if (
      Array.isArray(timelineDetails?.listItems) &&
      timelineDetails?.listItems?.length > 0
    ) {
      return (
        <Accordion
          defaultActiveKey={'timeline-details'}
          style={S.AccordionStyle}
        >
          <Accordion.Item eventKey={'timeline-details'}>
            <Accordion.Header style={S.HeaderStyle}>
              <h5 className="fw-bold p-2">{timelineDetails?.title}</h5>
            </Accordion.Header>
            <Accordion.Body>
              <TimelineComp items={timelineDetails?.listItems} />
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      );
    } else if (
      Array.isArray(timelineDetails?.listItems) &&
      timelineDetails?.listItems?.length === 0
    ) {
      return (
        <div style={{ display: 'block' }} className={'m-5 p-5'}>
          <Spinner animation="border" variant="primary" size="lg" />
        </div>
      );
    }
  };
  return (
    <>
      {policyDetails && (
        <Accordion defaultActiveKey={'policy-details'} style={S.AccordionStyle}>
          <Accordion.Item eventKey={'policy-details'}>
            <Accordion.Header style={S.HeaderStyle}>
              <h5 className="fw-bold p-2">{policyDetails?.title}</h5>
            </Accordion.Header>
            <Accordion.Body>
              <ListItemsComp listItems={policyDetails?.listItems} />
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      )}
      {beneficiaryDetails && (
        <Accordion
          defaultActiveKey={'beneficiary-details'}
          style={S.AccordionStyle}
        >
          <Accordion.Item eventKey={'beneficiary-details'}>
            <Accordion.Header style={S.HeaderStyle}>
              <h5 className="fw-bold p-2">{beneficiaryDetails?.title}</h5>
            </Accordion.Header>
            <Accordion.Body>
              <ListItemsComp listItems={beneficiaryDetails?.listItems} />
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      )}
      {useOfProceedDetails && (
        <Accordion
          defaultActiveKey={'useOfProceeds-details'}
          style={S.AccordionStyle}
        >
          <Accordion.Item eventKey={'useOfProceeds-details'}>
            <Accordion.Header style={S.HeaderStyle}>
              <h5 className="fw-bold p-2">{useOfProceedDetails?.title}</h5>
            </Accordion.Header>
            <Accordion.Body>
              <CheckedItems listItems={useOfProceedDetails?.listItems} />
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      )}
      {_getTimeline()}
    </>
  );
};

AccordionComp.defaultProps = {};
